import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    loadContractFlantListStatus: 'idle',
    loadContractFlantListError: undefined as any,
    loadContractFlantListLastParams: undefined,
    createFlantStatus: 'idle',
    createFlantError: undefined as any,
    updateFlantStatus: 'idle',
    updateFlantError: undefined as any,
    deleteFlantStatus: 'idle',
    deleteFlantError: undefined as any,

    flantList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
}

export const loadContractFlantList = createAsyncThunk('contractFlantSlice/loadContractFlantList', async ({ parentModel, forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadContractFlantListLastParams } = getState().contractFlantSlice

    const url = `/api/ixweb/flant/?obj=${parentModel.OBJNR}&TYP=0&FLNO=${parentModel.FLSTMNR}&MIN_DAT=${parentModel.BEGIN}&MAX_DAT=${parentModel.END}`
    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadContractFlantListLastParams && !forceReload) {
        return
    }

    const res = await client.get(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
})
export const createFlant = createAsyncThunk('contractFlantSlice/createFlant', async (flant: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/flant/`

    const res = await client.post(url, prepareData(flant))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...flant, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateFlant = createAsyncThunk('contractFlantSlice/updateFlant', async (flant: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/flant/${flant.HDR_ID}/`

    const res = await client.put(url, prepareData(flant))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return flant
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteFlant = createAsyncThunk('contractFlantSlice/deleteFlant', async (id: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/flant/${id}/`

    const res = await client.delete(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const FlantSlice = createSlice({
    name: 'contractFlantSlice',
    initialState,
    reducers: {
        resetloadContractFlantListError: (state) => {
            state.loadContractFlantListError = undefined
        },
        resetcreateFlantError: (state) => {
            state.createFlantError = undefined
        },
        resetupdateFlantError: (state) => {
            state.updateFlantError = undefined
        },
        resetdeleteFlantError: (state) => {
            state.deleteFlantError = undefined
        },
        removeFromFlantListById: (state, action) => {
            state.flantList = state.flantList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
    },
    extraReducers: builder => {
        builder.addCase(loadContractFlantList.pending, (state) => {
            state.loadContractFlantListStatus = 'pending'
            state.loadContractFlantListError = undefined
        })
        builder.addCase(loadContractFlantList.fulfilled, (state, action) => {
            state.loadContractFlantListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractFlantListLastParams = action.payload.params

            state.flantList = action.payload.data
        })
        builder.addCase(loadContractFlantList.rejected, (state, action) => {
            state.loadContractFlantListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractFlantListError = action.error.message
            } else {
                state.loadContractFlantListError = action.payload
            }
        })

        builder.addCase(createFlant.pending, (state) => {
            state.createFlantStatus = 'pending'
            state.createFlantError = undefined
        })
        builder.addCase(createFlant.fulfilled, (state, action) => {
            state.createFlantStatus = 'idle'


            state.flantList = [...state.flantList, action.payload]
        })
        builder.addCase(createFlant.rejected, (state, action) => {
            state.createFlantStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createFlantError = action.error.message
            } else {
                state.createFlantError = action.payload
            }
        })

        builder.addCase(updateFlant.pending, (state) => {
            state.updateFlantStatus = 'pending'
            state.updateFlantError = undefined
        })
        builder.addCase(updateFlant.fulfilled, (state, action) => {
            state.updateFlantStatus = 'idle'


            const i = state.flantList.findIndex((x: any) => x.HDR_ID === action.payload.HDR_ID)
            if (i === -1) { state.flantList.push(action.payload) }
            else { state.flantList[i] = { ...state.flantList[i], ...action.payload } }
        })
        builder.addCase(updateFlant.rejected, (state, action) => {
            state.updateFlantStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateFlantError = action.error.message
            } else {
                state.updateFlantError = action.payload
            }
        })

        builder.addCase(deleteFlant.pending, (state) => {
            state.deleteFlantStatus = 'pending'
            state.deleteFlantError = undefined
        })
        builder.addCase(deleteFlant.fulfilled, (state, action) => {
            state.deleteFlantStatus = 'idle'


            state.flantList = state.flantList.filter((x: any) => x.HDR_ID !== action.payload)
        })
        builder.addCase(deleteFlant.rejected, (state, action) => {
            state.deleteFlantStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteFlantError = action.error.message
            } else {
                state.deleteFlantError = action.payload
            }
        })

    }
})

export const {
    resetloadContractFlantListError,
    resetcreateFlantError,
    resetupdateFlantError,
    resetdeleteFlantError,
    removeFromFlantListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
} = FlantSlice.actions
export default FlantSlice.reducer
